import { useState } from "react";
import { RxCross1 } from "react-icons/rx";

const RejectCommentModal = (props) => {
  const { setIsOpenRejectionModal, submitRejectionComment, slug } = props;
  const [comment, setComment] = useState("");
  const [isCommentError, setIsCommentError] = useState(false);

  const submitRejectionCommentHandler = (event) => {
    event.preventDefault();
    if (comment === "") {
      setIsCommentError(true);
      return;
    }
    submitRejectionComment(comment, slug);
  };

  const handleCloseModal = () => {
    setIsOpenRejectionModal(false);
  };

  const onChangeCommentHandler = (event) => {
    setIsCommentError(false);
    const value = event?.target?.value ?? "";
    setComment(value);
  };

  return (
    <div className="fixed inset-0 bg-gray-900 backdrop-blur-sm  bg-opacity-50 flex items-center justify-center z-50">
      <div className="relative bg-[#150c3f] p-6 rounded-lg shadow-lg text-center w-full max-w-[500px]">
        <button
          className="absolute top-0 sm:right-[-20px] right-0 text-white rounded focus:outline-none text-lg"
          type="button"
          onClick={handleCloseModal}
        >
          <RxCross1 />
        </button>
        <div>
          <h1 className="text-white text-2xl mb-3">Submit Decline Reason</h1>
          <form onSubmit={submitRejectionCommentHandler}>
            <div className="mb-3">
              <textarea
                title="Please write the reason"
                placeholder="Please write the reason"
                className="block w-full text-white px-3 py-2 bg-[#372F5B] rounded-md shadow-sm focus:outline-none focus:ring focus:ring-red-500 focus:ring-opacity-50 min-h-[150px]"
                value={comment}
                onChange={onChangeCommentHandler}
              />
              <p
                className={`error text-red-500 text-left text-xs ${
                  !isCommentError ? "invisible" : ""
                }`}
              >
                **Decline reason is required
              </p>
            </div>
            <button
              type="submit"
              className="bg-red-600 py-2 px-3 text-sm text-white w-full rounded-lg"
            >
              Submit
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RejectCommentModal;
